export class ObjectQueriesTags {
  static root() {
    return ["object"] as const;
  }

  static getAllObjects({ projectId }: { projectId: string }) {
    return [
      "project",
      projectId,
      ...ObjectQueriesTags.root(),
      "allObjects",
    ] as const;
  }

  static getObject(params: { objectId: string }) {
    return [...ObjectQueriesTags.root(), params.objectId] as const;
  }
}
